export const ROVO_DEV_BASE_PATH = '/rovodev';
export const DEVAI_BASE_PATH = '/devai';
export const STAGING_PUBLIC_PATH =
	'https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/';
export const PROD_PUBLIC_PATH = 'https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/';
export const STG_BITBUCKET_DOMAIN = 'integration.bb-inf.net';
export const PROD_BITBUCKET_DOMAIN = 'bitbucket.org';
export const BITBUCKET_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';
export const GITHUB_INSTALL_LINK =
	'https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud';
export const GITHUB_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/';
export const BITBUCKET_MANAGE_LINK = '/secure/admin/ConfigureDvcsOrganizations!default.jspa';
export const ROVO_DEV_DOCS_HOME_LINK =
	'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents/';
export const CODING_AGENTS_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU';
export const CODE_REVIEWER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA';
export const DEPLOYMENT_SUMMARIZER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc';
export const BBC_AGENTS_SETTINGS_LINK_PROD = 'https://bitbucket.org/account/workspaces/';
export const BBC_AGENTS_SETTINGS_LINK_STG = 'https://integration.bb-inf.net/account/workspaces/';
export const PIPELINE_TROUBLESHOOTER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU';
export const CODE_SEARCH_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY';
export const ROVO_DEV_CLI_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWY5NjhmMDIyNjgzNDkxY2IyNjk4OTViOGIzZjM4ZDc';
export const ADMIN_HUB_BASE_URL_PROD = 'https://admin.atlassian.com';
export const ADMIN_HUB_BASE_URL_STG = 'https://admin.stg.atlassian.com';
export const GITHUB_MANAGE_LINK_PROD =
	'/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin';
export const GITHUB_MANAGE_LINK_STG =
	'/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin';
export const DEPLOYMENT_SUMMARIZER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ';
export const PIPELINE_TROUBLESHOOTER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM';
export const JOIN_WAITLIST_LINK =
	'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1';
export const ROVO_DEV_CLI_READ_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/Yzc2NzI4MTk3YTBhNDdiYjkzZDhhZTc3MjE0ZmE4Y2Q';
export const ROVO_DEV_CLI_INTRO_URL =
	'https://developer.atlassian.com/cloud/acli/guides/introduction/';
export const ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-macos/';
export const ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-linux/';
export const ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-windows/';
export const ROVO_DEV_CLI_TOKENS_URL =
	'https://id.atlassian.com/manage-profile/security/api-tokens?autofillToken&expiryDays=max&appId=rovodev&selectedScopes=all';
export const GITLAB_SERVICE_ACCOUNT_TOKENS_URL =
	'https://docs.gitlab.com/user/profile/service_accounts/#view-and-manage-personal-access-tokens-for-a-service-account';
export const BITBUCKET_DATA_CENTER_TOKENS_URL =
	'https://confluence.atlassian.com/bitbucketserver0717/personal-access-tokens-1087535496.html';
export const ROVO_DEV_CLI_BETA_LEARN_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM';
export const ROVO_DEV_ACTIVATE_CODE_REVIEWS_IN_YOUR_REPOS_URL =
	'https://support.atlassian.com/rovo/docs/activate-code-reviews-in-your-repository/';
export const ROVO_DEV_LEARN_ABOUT_GRANTING_ACCESS_URL =
	'https://support.atlassian.com/rovo/docs/add-rovo-dev-standard-to-your-site/#Add-users-to-Rovo-Dev-Standard-user-group';

export const ROVO_DEV_REQUEST_ACCESS_URL = 'https://id.atlassian.com/join/user-access';
export const ROVO_DEV_SIGNUP_URL = 'https://www.atlassian.com/try/cloud/signup?bundle=devai';
export const ROVO_DEV_USAGE_URL =
	'https://support.atlassian.com/rovo/docs/view-your-rovo-dev-credit-usage';
export const ROVO_DEV_CLI_TUTORIALS_PLAYLIST_URL =
	'https://www.youtube.com/watch?v=OTgOulR4IZ0&list=PLaD4FvsFdarQj5c0ou9qrKMD5S302V9D0';
export const ROVO_DEV_IDE_VCODE_LEARN_MORE_LINK =
	'https://marketplace.visualstudio.com/items?itemName=Atlassian.atlascode&ssr=false#overview';
export const ROVO_DEV_AUTOMATION_REQUEST_ACCESS_LINK =
	'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1/group/1/create/144';

export const GITHUB_FOR_ATLASSIAN_INSTALLATION_PROD_URL =
	'https://marketplace.atlassian.com/apps/1219592/github-for-atlassian?hosting=cloud&tab=overview';
export const GITHUB_FOR_ATLASSIAN_INSTALLATION_STAGING_URL =
	'https://marketplace-admin.stg.internal.atlassian.com/apps/1243270/github-for-jira-staging?hosting=cloud&tab=overview';
export const GITHUB_FOR_JIRA_BASE_URL_PROD = 'https://github.atlassian.com';
export const GITHUB_FOR_JIRA_BASE_URL_STG = 'https://github.stg.atlassian.com';
export const ROVO_DEV_SOFTWARE_URL = 'https://www.atlassian.com/software/rovo-dev';

export const ROVO_DEV_WORK_IN_IDE_URL =
	'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-the-ide/';

// Outbound Auth containers holding the DevAI OAuth grants the Connected accounts card reports on.
export const DEVAI_OUTBOUND_AUTH_CONTAINER_ID_PROD =
	'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7';
export const DEVAI_OUTBOUND_AUTH_CONTAINER_ID_STG =
	'9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f';

// Atlassian account page listing every third-party grant. Revoking is not
// reachable from the browser — Outbound Auth's `/externalAccount/*` routes are
// rejected by PoCo for cookie-authed callers — so Disconnect sends users here.
export const MANAGE_CONNECTED_APPS_URL_PROD = 'https://id.atlassian.com/manage-profile/apps';
export const MANAGE_CONNECTED_APPS_URL_STG =
	'https://id.stg.internal.atlassian.com/manage-profile/apps';
